import * as React from 'react';
import { useRecordContext } from 'react-admin';

import { makeStyles, Typography } from '@material-ui/core';

import { POR_PESO_VARIAVEL, getEstoqueLabel } from '../../../utils';

const useStyles = makeStyles((theme) => ({
  pendente: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    color: 'white',
    backgroundColor: '#f44336',
  },
  confirmado: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    color: 'white',
    backgroundColor: '#4caf50',
  },
}));

const ValorField = (props) => {
  const record = useRecordContext(props);
  const unidades = record ? record.record.unidades : 0;
  const showUnidades = record
    ? record.record.produto.unidade.tipo !== POR_PESO_VARIAVEL
    : false;
  const produto = record ? record.record.produto : null;
  return (
    <Typography
      variant="subtitle1"
      style={{
        // color: tipo === 'Receita' ? '#4caf67' : '#f44336',
        fontWeight: 'bold',
      }}
    >
      {true ? getEstoqueLabel(produto, unidades) : '-'}
    </Typography>
  );
};

export default ValorField;
